// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1wG-9","upload":"Small_upload__1owxA","imageWrap":"Small_imageWrap__331gX","removeBtn":"Small_removeBtn__2gQ8n"};